export default __webpack_public_path__ + "static/media/metamask-logo.f45b965c.png";